/**
 * @summary Contains the slider preact component.
 */

import { h, Component } from 'preact';
import debounce from 'lodash/debounce';
import SliderMain from './SliderMain';
import SliderThumbs from './SliderThumbs';

/**
 * @summary Slider preact preact component.
 *
 * @class
 * @extends {Component}
 */
export default class Slider extends Component {
	constructor( props ) {
		super( props );

		this.state = {
			activeIndex: 0
		};

		this.initialLoad = true;
		this.autoScrolled = false;

		this.handleThumbnailClick = this.handleThumbnailClick.bind( this );
		this.handleButtonClick = this.handleButtonClick.bind( this );
		this.setMainRef = this.setMainRef.bind( this );

		// React to autscrolling from thumbnail click
		this.autoscrollFocus = debounce( this.autoscrollFocus.bind( this ), 200 );
	}

	componentDidMount() {
		window.addEventListener( 'scroll', this.autoscrollFocus );
	}

	componentWillUnmount() {
		window.removeEventListener( 'scroll', this.autoscrollFocus );
	}

	/**
	 * @summary Focuses on main element.
	 */
	autoscrollFocus() {
		if ( this.autoScrolled ) {
			this.mainElement.focus();
			this.autoScrolled = false;
		}
	}

	/**
	 * @summary Handles a thumbnail click.
	 *
	 * @listens document:click
	 *
	 * @param {number} index The index number of the slide to make active.
	 */
	handleThumbnailClick( index ) {
		this.setState({
			activeIndex: index
		});

		this.autoScrolled = true;
		this.mainElement.scrollIntoView({
			behavior: 'smooth',
			block: 'start',
			inline: 'nearest'
		});
	}

	/**
	 * @summary Handles a navigation button click.
	 *
	 * @listens document:click
	 *
	 * @param {('left'|'right')} direction The direction to page once.
	 */
	handleButtonClick( direction ) {
		this.setState( ({ activeIndex }) => {
			const endIndex = this.props.data.length - 1;

			// Cases for looping to the other end of the list
			if ( direction === 'right' && activeIndex === endIndex ) {
				return { activeIndex: 0 };
			} else if ( direction === 'left' && activeIndex === 0 ) {
				return { activeIndex: endIndex };
			}

			return { activeIndex: activeIndex + ( direction === 'right' ? 1 : -1 ) };
		});
	}

	/**
	 * @summary Sets a reference to the main slider pane.
	 *
	 * @param {HTMLElement} element The main slider window element.
	 */
	setMainRef( element ) {
		this.mainElement = element;
	}

	render({ data }, { activeIndex }) {
		if ( this.initialLoad ) {
			this.initialLoad = false;
		}

		return (
			<div>
				<SliderMain
					data={data}
					activeIndex={activeIndex}
					setRef={this.setMainRef}
					handleButtonClick={this.handleButtonClick}
				/>
				<div class="c-slider__divider u-mb-40 u-mt-30">
					<div class="c-slider__arrow c-slider__arrow"/>
				</div>
				<SliderThumbs
					data={data}
					activeIndex={activeIndex}
					handleClick={this.handleThumbnailClick}
				/>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/js/components/Slider.js